import { render, staticRenderFns } from "./createRedAct.vue?vue&type=template&id=5e249f71&scoped=true&"
import script from "./createRedAct.vue?vue&type=script&lang=js&"
export * from "./createRedAct.vue?vue&type=script&lang=js&"
import style0 from "./createRedAct.vue?vue&type=style&index=0&id=5e249f71&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e249f71",
  null
  
)

component.options.__file = "createRedAct.vue"
export default component.exports